import { addIssue } from './add-issue';
import { z } from 'zod';
import { hasEmptyPrice, isValidNumber } from './common';
import { getRequiredYears } from './getRequiredYears';

export const validateFinalEnergyPrice = (
  finalEnergyPrice: Record<string, any> | undefined,
  basePath: Array<string | number>,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
  supplyStartDate?: string | null | Date,
  supplyFinalDate?: string | null | Date,
  globalSupplyStartDate?: string | null | Date,
  globalSupplyFinalDate?: string | null | Date,
  aux__useDifferentPeriodsByUnit?: boolean,
): boolean => {
  let hasErrors = false;

  if (!finalEnergyPrice) {
    addIssue(ctx, [...basePath], 'Preços finais de energia são obrigatórios');
    return false;
  }

  const requiredYears = getRequiredYears(
    supplyStartDate,
    supplyFinalDate,
    globalSupplyStartDate,
    globalSupplyFinalDate,
    aux__useDifferentPeriodsByUnit,
  );

  if (requiredYears.length === 0) {
    const projKeys: string[] = [];
    const maybeProjection = (finalEnergyPrice as any)?.rawPriceList ?? null;
    if (maybeProjection && typeof maybeProjection === 'object') {
      Object.keys(maybeProjection).forEach((k) => {
        projKeys.push(k.startsWith('year') ? k : `year${k}`);
      });
    }

    if (projKeys.length > 0) {
      requiredYears.push(...projKeys);
    }
    if (requiredYears.length === 0 && basePath.includes('.targetScenarios')) {
      addIssue(ctx, [...basePath], 'Não foi possível determinar os anos necessários para validação 2');
      return false;
    }
  }

  requiredYears.forEach((year) => {
    const price = finalEnergyPrice[year];
    if (hasEmptyPrice(price)) {
      addIssue(ctx, [...basePath, year], `Preço final de energia para ${year.replace('year', '')} é obrigatório`);
      hasErrors = true;
    } else if (isValidNumber(price)) {
      addIssue(
        ctx,
        [...basePath, year],
        `Preço final de energia para ${year.replace('year', '')} deve ser um número válido maior ou igual a zero`,
      );
      hasErrors = true;
    }
  });

  return !hasErrors;
};
